import { findNextAvailableGuideTourStepIndex } from '../utils/tourRuntime'
import type { GuideTourExitKind } from '../utils/modals'
import type { GuideTourDefinition } from '../types'
import {
  getGuideTourStepRoute,
  isMultiRouteGuideTour,
  matchGuideTourRoute,
} from './utils'

export const getGuideTourOriginRoute = (
  tour: GuideTourDefinition
): string | null => {
  const firstStepIndex = findNextAvailableGuideTourStepIndex(tour, 0)

  if (firstStepIndex === null) {
    return null
  }

  const step = tour.steps[firstStepIndex]

  if (!step) {
    return null
  }

  return getGuideTourStepRoute(tour, step) ?? null
}

/**
 * Multi-route onboard tours should return the seller to where the walkthrough
 * started so route-scoped novidades on the ending page do not chain immediately.
 */
export const shouldRestoreGuideTourOriginRouteOnExit = (
  tour: GuideTourDefinition,
  pathname: string,
  exitKind: GuideTourExitKind
): boolean => {
  if (exitKind !== 'completed' && exitKind !== 'skipped') {
    return false
  }

  if (tour.type !== 'onboard' || !isMultiRouteGuideTour(tour)) {
    return false
  }

  const originRoute = getGuideTourOriginRoute(tour)

  if (!originRoute) {
    return false
  }

  return !matchGuideTourRoute(originRoute, pathname)
}
